import { combineEpics } from 'redux-observable'
import { debounceTime, switchMap } from 'rxjs/operators'

import { Epic } from 'modules/store'

import { AppProviders } from '../../../app/app.module'
import * as fromActions from './multiselect-adapter.actions'

export const multiselectOptionsEpic: Epic<fromActions.MultiselectActions, any, AppProviders> = (
  actions$,
  _,
  { httpClient }
) => {
  return actions$.ofType<fromActions.GetMultiselectDataAction>(fromActions.GET_MULTISELECT_DATA).pipe(
    debounceTime(350),
    switchMap(({ payload }) =>
      httpClient
        .get<{ items: any[]; count: number }>(payload.endpointUrl, {
          params: payload.params,
        })
        .then(
          ({ data }) => new fromActions.GetMultiselectDataSuccessAction({ storeId: payload.storeId, data: data.items })
        )
        .catch((reason) => new fromActions.GetMultiselectDataFailureAction(reason))
    )
  )
}

export default combineEpics(multiselectOptionsEpic)



// WEBPACK FOOTER //
// ./src/modules/forms/multiselect-adapter/multiselect-adapter.epic.ts